import { render, staticRenderFns } from "./BmsEnter.vue?vue&type=template&id=8f35a6c0&scoped=true&"
import script from "./BmsEnter.vue?vue&type=script&lang=js&"
export * from "./BmsEnter.vue?vue&type=script&lang=js&"
import style0 from "./BmsEnter.vue?vue&type=style&index=0&id=8f35a6c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f35a6c0",
  null
  
)

export default component.exports